<div cdkTrapFocus role="dialog" aria-labelledby="modal-header">
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@AddNewPaymentCard" id="modal-header">Add New Payment Card</h3>
    <button type="button" class="close" aria-label="Close" ngbAutoFocus (click)="onCancel()">
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body modal_body_ticket">
    <div class="card-label-container">
      <div class="label-wrapper">
        <label for="card-label-input" i18n="@@CardLabel">Card label</label>:
        <div class="asterisk">*</div>
      </div>
      <div class="input-wrapper">
        <input [(ngModel)]="label" id="card-label-input" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      id="button_ok"
      appButton="small"
      aria-label="Ok"
      i18n-aria-label
      [disabled]="!label"
      (click)="submit()"
      (keydown.enter)="submit()"
      (keydown.space)="submit()"
      i18n="@@Ok"
    >
      Ok
    </button>
  </div>
</div>
